import Tabs from "../../../components/Tabs";
import { tabConfigType } from "../../../models/Tabs";
import DeptCheckedOutVehicles from './DeptCheckedOutVehicles';
import DeptReservationTable from './DeptReservationTable';


export default function DeptCheckOutReservationHolder(){
    const tabConfig: tabConfigType[] = [
        { label: 'CheckOuts', key: 0, component: <DeptCheckedOutVehicles  /> },    
        {
          label: "Reservations",
          key: 1, 
          component: (<DeptReservationTable/>)
        }
      ];
    
      return (
        <>
          <Tabs tabConfig={tabConfig} />
        </>
      );
}